import React from 'react';

export const NoTask = ({
  width,
  height,
  color,
}: {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    width="336"
    height="202"
    viewBox="0 0 336 202"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M211.665 33.4431C213.74 36.5975 215.118 40.0105 215.837 43.4993C228.743 35.2524 245.902 38.8925 254.364 51.7601C262.916 64.7629 259.35 82.2641 246.399 90.8502L241.06 94.3904C242.908 95.8107 244.555 97.5601 245.909 99.6198C252.425 109.527 249.708 122.861 239.841 129.403L159.091 182.94C149.224 189.481 135.943 186.754 129.428 176.847C128.073 174.787 127.118 172.579 126.543 170.315L122.473 173.013C109.522 181.599 92.0914 178.019 83.5398 165.016C75.2151 152.358 78.3735 135.438 90.4938 126.628C87.5723 124.592 84.9803 121.975 82.901 118.813C74.1459 105.501 77.7968 87.5831 91.0556 78.7925L171.805 25.2556C185.064 16.4651 202.91 20.1307 211.665 33.4431Z"
      fill="#EFEEF8"
    />
    <path
      d="M209.985 188.2L209.997 193.732L206.587 193.732L206.587 188.212L201.089 188.212V184.788L206.599 184.8L206.587 179.268L209.997 179.268L209.985 184.8L215.495 184.788L215.495 188.212L209.985 188.2Z"
      fill="#EBEBF0"
    />
    <ellipse
      cx="256.427"
      cy="21.5261"
      rx="6.68763"
      ry="7.10765"
      fill="#EBEBF0"
    />
    <ellipse
      cx="42.2485"
      cy="168.373"
      rx="5.18023"
      ry="5.50558"
      fill="#EBEBF0"
    />
    <ellipse
      cx="140.736"
      cy="10.0017"
      rx="3.48759"
      ry="3.50168"
      fill="#EBEBF0"
    />
    <ellipse
      cx="32.1802"
      cy="31.6677"
      rx="3.02171"
      ry="3.03392"
      fill="#EBEBF0"
    />
    <ellipse
      cx="76.0901"
      cy="55.1282"
      rx="3.02171"
      ry="3.03392"
      fill="#EBEBF0"
    />
    <ellipse
      cx="283.171"
      cy="159.834"
      rx="3.02171"
      ry="3.03392"
      fill="#EBEBF0"
    />
    <ellipse
      cx="63.0049"
      cy="131.527"
      rx="3.02171"
      ry="3.03392"
      fill="#EBEBF0"
    />
    <rect
      x="8.68237"
      y="65.2462"
      width="272.884"
      height="30.7104"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.262 78.99C25.4871 79.2103 25.4911 79.5714 25.2709 79.7965L22.3187 82.8146C22.2114 82.9242 22.0644 82.9861 21.911 82.9861C21.7576 82.9861 21.6106 82.9242 21.5033 82.8146L19.856 81.1305C19.6357 80.9053 19.6397 80.5442 19.8649 80.3239C20.09 80.1037 20.4511 80.1077 20.6714 80.3328L21.911 81.6001L24.4554 78.9989C24.6757 78.7737 25.0368 78.7698 25.262 78.99Z"
      fill="#938DD9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4776 74.6581C22.0773 74.0585 23.0495 74.0585 23.6492 74.6581L28.5067 79.5156C29.1064 80.1153 29.1064 81.0875 28.5067 81.6872L23.6492 86.5447C23.0495 87.1444 22.0773 87.1444 21.4776 86.5447L16.6201 81.6872C16.0205 81.0875 16.0205 80.1153 16.6201 79.5156L21.4776 74.6581ZM22.7185 75.5888C22.6328 75.5031 22.494 75.5031 22.4083 75.5888L17.5508 80.4463C17.4651 80.532 17.4651 80.6709 17.5508 80.7565L22.4083 85.614C22.494 85.6997 22.6328 85.6997 22.7185 85.614L27.576 80.7565C27.6617 80.6709 27.6617 80.532 27.576 80.4463L22.7185 75.5888Z"
      fill="#938DD9"
    />
    <rect
      x="37.0682"
      y="75.8848"
      width="75.2032"
      height="3.77328"
      rx="0.94332"
      fill="#E0DFE6"
    />
    <rect
      x="37.0682"
      y="81.5447"
      width="31.8468"
      height="3.77328"
      rx="0.94332"
      fill="#E0DFE6"
    />
    <rect
      x="153.356"
      y="74.6755"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="172.693"
      y="74.6755"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="192.03"
      y="74.6755"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="211.367"
      y="74.6755"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="230.704"
      y="74.6755"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="250.041"
      y="72.5876"
      width="16.0276"
      height="16.0276"
      rx="8.0138"
      fill="#E0DFE6"
    />
    <rect
      x="8.68237"
      y="65.2462"
      width="272.884"
      height="30.7104"
      stroke="#938DD9"
      strokeWidth="0.623774"
    />
    <rect
      x="31.6541"
      y="83.6665"
      width="272.884"
      height="31.5878"
      fill="white"
    />
    <circle
      cx="45.5351"
      cy="99.4604"
      r="5.09825"
      stroke="#9997AF"
      strokeWidth="1.14067"
    />
    <path
      d="M42.7821 99.2554L44.7541 101.227L48.2881 97.6934"
      stroke="#9997AF"
      strokeWidth="1.14067"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="60.0399"
      y="94.7438"
      width="75.2032"
      height="3.77328"
      rx="0.94332"
      fill="#E0DFE6"
    />
    <rect
      x="60.0399"
      y="100.404"
      width="31.8468"
      height="3.77328"
      rx="0.94332"
      fill="#E0DFE6"
    />
    <rect
      x="175.45"
      y="93.5345"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="194.787"
      y="93.5345"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="214.124"
      y="93.5345"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="233.461"
      y="93.5345"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="252.798"
      y="93.5345"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="272.135"
      y="91.4466"
      width="16.0276"
      height="16.0276"
      rx="8.0138"
      fill="#E0DFE6"
    />
    <rect
      x="31.6541"
      y="83.6665"
      width="272.884"
      height="31.5878"
      stroke="#938DD9"
      strokeWidth="0.623774"
    />
    <rect
      x="55.5881"
      y="106.48"
      width="272.884"
      height="31.5878"
      fill="white"
    />
    <circle
      cx="69.4692"
      cy="122.274"
      r="5.09825"
      stroke="#9997AF"
      strokeWidth="1.14067"
    />
    <path
      d="M66.7162 122.069L68.6882 124.041L72.2222 120.507"
      stroke="#9997AF"
      strokeWidth="1.14067"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="83.974"
      y="117.557"
      width="75.2032"
      height="3.77328"
      rx="0.94332"
      fill="#E0DFE6"
    />
    <rect
      x="83.9739"
      y="123.217"
      width="31.8468"
      height="3.77328"
      rx="0.94332"
      fill="#E0DFE6"
    />
    <rect
      x="199.384"
      y="116.348"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="218.721"
      y="116.348"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="238.058"
      y="116.348"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="257.395"
      y="116.348"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="276.732"
      y="116.348"
      width="11.8517"
      height="11.8519"
      rx="1.24755"
      fill="#EBEBF0"
    />
    <rect
      x="296.069"
      y="114.26"
      width="16.0276"
      height="16.0276"
      rx="8.0138"
      fill="#E0DFE6"
    />
    <rect
      x="55.5881"
      y="106.48"
      width="272.884"
      height="31.5878"
      stroke="#938DD9"
      strokeWidth="0.623774"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M257.858 159.552C265.654 159.552 271.974 153.232 271.974 145.437C271.974 137.641 265.654 131.321 257.858 131.321C250.063 131.321 243.743 137.641 243.743 145.437C243.743 153.232 250.063 159.552 257.858 159.552ZM257.858 160.868C266.381 160.868 273.29 153.959 273.29 145.437C273.29 136.914 266.381 130.005 257.858 130.005C249.336 130.005 242.427 136.914 242.427 145.437C242.427 153.959 249.336 160.868 257.858 160.868Z"
      fill="#8B89A4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M258.777 139.027C258.777 138.52 258.366 138.11 257.86 138.11C257.353 138.11 256.942 138.52 256.942 139.027V144.518L251.453 144.518C250.946 144.518 250.535 144.928 250.535 145.435C250.535 145.942 250.946 146.353 251.453 146.353L256.942 146.353V151.842C256.942 152.349 257.353 152.76 257.86 152.76C258.366 152.76 258.777 152.349 258.777 151.842V146.353L264.268 146.353C264.774 146.353 265.185 145.942 265.185 145.435C265.185 144.928 264.774 144.518 264.268 144.518L258.777 144.518V139.027Z"
      fill="#938DD9"
    />
  </svg>
);
